import { ProductTypeUrlSuffix } from '../models/product-type-url-suffix';
import { ProductTypeUrlSuffixPlural } from '../models/product-type-url-suffix-plural';
/**
 * @internal
 */
export var getProductTypeUrlSuffix = function (productType, isProductTypePlural) {
    var productTypeUrlSuffix;
    switch (productType) {
        case "g" /* Group */:
            productTypeUrlSuffix = isProductTypePlural ? ProductTypeUrlSuffixPlural.Group : ProductTypeUrlSuffix.Group;
            break;
        case "p" /* Product */:
            productTypeUrlSuffix = isProductTypePlural ? ProductTypeUrlSuffixPlural.Product : ProductTypeUrlSuffix.Product;
            break;
        case "f" /* Family */:
        default:
            productTypeUrlSuffix = isProductTypePlural ? ProductTypeUrlSuffixPlural.Family : ProductTypeUrlSuffix.Family;
            break;
    }
    return productTypeUrlSuffix;
};
